import { render } from "./SendMessage.vue?vue&type=template&id=ab17e2e8"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"
script.render = render

export default script